import { useState, useEffect, useCallback } from "react";
import { useApi } from "./useApi";
import { COMPANY_KEY } from "../config/company";

/**
 * Hook para buscar os dados da empresa (loja) atual
 * GET /companies/{COMPANY_KEY}
 *
 * A API devolve JSON direto (CompanyResponseDTO), sem envelope:
 * { id, code, name, contactName, contactPhone, available, delivery, description,
 *   logoUrl, deliveryDescription, pickupDescription, eventsDescription,
 *   businessHoursWeekdays, businessHoursWeekend, footerInfo }
 * Campos nulos são omitidos. Por segurança também aceita { data: [...] } / { data: {...} }.
 *
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true] - Só busca quando true (ex.: depois do login guest)
 */
export const useCompany = ({ enabled = true } = {}) => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const api = useApi();

  const fetchCompany = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get(`/companies/${COMPANY_KEY}`);

      const data = Array.isArray(response?.data)
        ? response.data[0]
        : response?.data && typeof response.data === "object"
          ? response.data
          : Array.isArray(response)
            ? response[0]
            : response;

      setCompany(data || null);
      return data || null;
    } catch (err) {
      console.error("❌ Erro ao buscar dados da empresa:", err);
      setError(err.data?.message || "Erro ao buscar dados da empresa.");
      return null;
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    if (enabled) fetchCompany();
  }, [enabled, fetchCompany]);

  return { company, loading, error, fetchCompany };
};
